export default __webpack_public_path__ + "static/media/logo-extensivo-base-2023.3498ef62.svg";